import React from 'react'
import * as Icons from "react-feather";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import {
    faFilePdf,
    faFileExcel,
    faPrint,
  } from "@fortawesome/free-solid-svg-icons";

function PageHeader(props) {
    let headerOptionPdf, headerOptionExcel, headerOptionExcelImport, headerOptionPrint, headerOptionRefresh, headerOptionAddButton, allOptions;
    if(props.showPDF === true){
        headerOptionPdf = <li key="pdf"><Link to="" onClick={props.onPdfExport}  title="Pdf"><FontAwesomeIcon icon={faFilePdf} /></Link></li>
    }
    if(props.showExcel === true){
        headerOptionExcel = <li key="Excel"><Link to=""  onClick={props.onExcelExport} title="Excel"><FontAwesomeIcon icon={faFileExcel} /></Link></li>
    }
    if(props.showPrint === true){
        headerOptionPrint = <li key="print"><Link to="" title="print"><FontAwesomeIcon icon={faPrint} /></Link></li>
    }
    if(props.showRefresh === true){
        headerOptionRefresh = <li key="refresh">
            <Link
                className="me-2 p-2"
                to=""
                onClick={props.onRefresh}
                title="Edit"
                >
                <Icons.RotateCcw className="feather-rotate-ccw" />
            </Link>
            </li>
    }
    if(props.showAddButton === true){
        headerOptionAddButton = 
        <div className="page-btn">
            <button className="btn btn-added" onClick={props.onModelOpen}>
                <Icons.PlusCircle className="me-2" />
                Add New {props.displayModule}
            </button>
        </div>
    }
    if(props.showImportExcel === true){
        headerOptionExcelImport = 
            <li key="refresh">
                <Link
                    className="me-2 p-2"
                    to=""
                    onClick={props.onImport}
                    title="Edit"
                    >
                    <Icons.Download className="feather-download" />
                </Link>
            </li>
    }
    
    return (
        <>
            <div className="page-header">
                <div className="add-item d-flex">
                    <div className="page-title">
                        <h4>{props.displayModule}</h4>
                        <h6>{props.displayText === undefined ? "Manage your " : props.displayText} {props.displayModule}</h6>
                    </div>
                </div>
                <ul className="table-top-head">
                    {[headerOptionPdf, headerOptionExcel, headerOptionPrint, headerOptionRefresh, headerOptionExcelImport].filter(Boolean)}
                </ul>
                {headerOptionAddButton}
            </div>
        </>
    )
}

export default PageHeader